import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController, AlertController, LoadingController, ActionSheetController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup, AbstractControl } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { Storage } from '@ionic/storage';

import { BusinessProductSubCategoryModifierManagerHandler } from '../../providers/business-product-subcategory-modifier-handler';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-product-subcategory-modifier-manager',
  templateUrl: 'business-product-subcategory-modifier-manager.html',
})
export class BusinessProductSubcategoryModifierManagerPage {
	group: any;
	modifier: any;
	private form : FormGroup;
	loader: any;
	filePath: any;
	isLoading: boolean = false;
	saveIsLoading: boolean = false;
	deleteIsLoading: boolean = false;

  	constructor(  		
  		private toastCtrl: ToastController,
		public navCtrl: NavController, 
		public viewCtrl: ViewController,
		public navParams: NavParams,
		private formBuilder: FormBuilder,
		public managerHandler: BusinessProductSubCategoryModifierManagerHandler,
		public storage: Storage,
		public loadingCtrl: LoadingController,
		public alertCtrl: AlertController,
		public globals: Globals,
		public actionSheetCtrl: ActionSheetController,
		public _DomSanitizer: DomSanitizer
		) {

  		this.group = navParams.data["group"];
  		this.modifier = navParams.data["modifier"];
		
	    this.form = this.formBuilder.group({
	    	"Id": [''],
		  	"ModifierName":  ['', Validators.required],
		  	"ModifierGroupId": [''],
		    "IsActive": [false],
	   	});   

	   	// this.form.controls.CategoryId = this.category.Id
  	}

  	ionViewWillEnter() {
		if(this.modifier.Id){
	   		this.load(this.modifier.Id);
	    } else {

	    	var groupOption = {
	    		ModifierGroupId: this.group.Id
	    	}

	    	this.form.patchValue(
				groupOption
		    )
	    }
	}

	load(id){
		this.isLoading = true;

		this.managerHandler.getById(id, (result)=>{
		  	
		  	if(result.Id != ''){
		  		this.modifier = result;

		  		this.form.patchValue(
					this.modifier
		    	)
		  	}

		  	this.isLoading = false;
		})
	}

	delete(){
		this.deleteIsLoading = true;
		
		this.managerHandler.delete(this.modifier.Id, (result)=>{
			this.deleteIsLoading = true;

			if(result.Success)
				this.navCtrl.pop();
			else{
				let alert = this.alertCtrl.create({
	              title: 'Error',
	              subTitle: result.Message,
	              buttons: ['Ok']
	            });

	            alert.present();
			}
		});			
	}

	presentDeleteConfirmation() {
	  let alert = this.alertCtrl.create({
	    title: 'Confirm deletion',
	    message: 'Do you want to delete this modifier?',
	    buttons: [
	      {
	        text: 'Delete',
	        handler: () => {
	          console.log('Delete clicked');
	          this.delete()
	        }
	      },
	      {
	        text: 'Cancel',
	        role: 'cancel',
	        handler: () => {
	          console.log('Cancel clicked');
	        }
	      }
	    ]
	  });
	  alert.present();
	}

	onSubmit(){
		if(this.saveIsLoading)
			return
		
		this.saveIsLoading = true;

		if(this.form.value.Id != ''){

			console.log("entered update");

			this.managerHandler.update(this.form.value.Id, this.form.value, (result)=>{
				if(result.Success){
					let toast = this.toastCtrl.create({
						message: 'Modifier has been updated',
						duration: 3000,
						position: 'bottom'
					});

					toast.present();						
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}

				this.saveIsLoading = false;
			})

		} else {
			console.log("entered create");

			this.managerHandler.create(this.form.value, (result)=>{
				if(result.Success){
					this.load(result.Data.Id);
				} else {
					let alert = this.alertCtrl.create({
				    	title: 'Error',
				    	subTitle: result.Message,
				    	buttons: ['Ok']
				  	});
				  	
				  	alert.present();
				}
			  				  	
				this.saveIsLoading = false;
			})
		}		  	
	}
}


// WEBPACK FOOTER //
// ./src/pages/business-product-subcategory-modifier-manager/business-product-subcategory-modifier-manager.ts